import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Route } from 'react-router';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { extractFromArray } from '../../../../utils';
import Button, { ButtonGroup } from '../../../common/base/Button';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import Tooltip from '../../../common/base/Tooltip';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useCopyAsCurl from '../../../hooks/useCopyAsCurl';
import useEventAction from '../../../hooks/useEventActions';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { StyledViewNavActions, StyledViewContent, StyledViewLayout, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, ViewBreadcrumbsTitle } from '../../../layouts/ViewLayout';
import { DashboardContext } from '../DashboardContext';
import EventSidebar from '../Events/EventSidebar';
import NotFound from '../NotFound';
import { EventAttempts } from './EventAttempts';
import { EventOverview } from './EventOverview';
interface Query {
  selected_attempt_id?: string | string[];
}
const EventView: React.FC = () => {
  const $ = _c(115);
  const {
    id: event_id
  } = useParams();
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t0;
  if ($[0] !== query.selected_attempt_id) {
    t0 = extractFromArray(query.selected_attempt_id);
    $[0] = query.selected_attempt_id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selected_attempt_id = t0 as string;
  let t1;
  if ($[2] !== updateSearchQuery) {
    t1 = selected_attempt_id_0 => updateSearchQuery({
      selected_attempt_id: selected_attempt_id_0,
      tab: "attempts"
    });
    $[2] = updateSearchQuery;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onAttemptSelected = t1;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    subscription
  } = useContext(DashboardContext);
  let t2;
  if ($[4] !== event_id) {
    t2 = APIMethodKeys.events.get(event_id);
    $[4] = event_id;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== HookdeckAPI.events || $[7] !== event_id) {
    t3 = () => HookdeckAPI.events.get(event_id);
    $[6] = HookdeckAPI.events;
    $[7] = event_id;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      refreshInterval: 5000
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    data: event,
    mutate,
    error
  } = useSWR(t2, t3, t4);
  let t5;
  if ($[10] !== event) {
    t5 = event && APIMethodKeys.webhooks.get(event.webhook_id);
    $[10] = event;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== HookdeckAPI.webhooks || $[13] !== event?.webhook_id) {
    t6 = () => HookdeckAPI.webhooks.get(event?.webhook_id as string);
    $[12] = HookdeckAPI.webhooks;
    $[13] = event?.webhook_id;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    error: webhook_error,
    isLoading: webhook_loading
  } = useSWR(t5, t6);
  let t7;
  if ($[15] !== event_id) {
    t7 = APIMethodKeys.attempts.list({
      event_id
    });
    $[15] = event_id;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== HookdeckAPI.attempts || $[18] !== event_id) {
    t8 = () => HookdeckAPI.attempts.list({
      event_id
    });
    $[17] = HookdeckAPI.attempts;
    $[18] = event_id;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      refreshInterval: 5000
    };
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const {
    data: attempts,
    mutate: mutateAttempts
  } = useSWR(t7, t8, t9);
  let t10;
  if ($[21] !== event) {
    t10 = event && APIMethodKeys.bookmarks.list({
      event_data_id: event.event_data_id
    });
    $[21] = event;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== HookdeckAPI.bookmarks || $[24] !== event?.event_data_id) {
    t11 = () => HookdeckAPI.bookmarks.list({
      event_data_id: event?.event_data_id
    });
    $[23] = HookdeckAPI.bookmarks;
    $[24] = event?.event_data_id;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const {
    data: bookmarks,
    mutate: mutateBookmarks
  } = useSWR(t10, t11);
  let t12;
  if ($[26] !== event) {
    t12 = event && event.cli_id && APIMethodKeys.cli_clients.list({
      id: event.cli_id
    });
    $[26] = event;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== HookdeckAPI.cli_clients || $[29] !== event?.cli_id) {
    t13 = () => HookdeckAPI.cli_clients.list({
      id: event?.cli_id
    });
    $[28] = HookdeckAPI.cli_clients;
    $[29] = event?.cli_id;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const {
    data: cli_clients
  } = useSWR(t12, t13);
  let t14;
  if ($[31] !== event) {
    t14 = {
      event
    };
    $[31] = event;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const copyAsCurl = useCopyAsCurl(t14);
  const is_overview_tab = location.pathname.split("/").length === 3;
  const current_status = is_overview_tab ? "overview" : "attempts";
  const t15 = `/events/${event_id}`;
  let t16;
  if ($[33] !== t15) {
    t16 = {
      label: "Overview",
      key: "overview",
      to: t15
    };
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  const t17 = `/events/${event_id}/attempts`;
  const t18 = attempts?.models.length;
  let t19;
  if ($[35] !== t17 || $[36] !== t18) {
    t19 = {
      label: "Delivery attempts",
      key: "attempts",
      to: t17,
      badge_theme: "muted",
      badge_label: t18
    };
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t16 || $[39] !== t19) {
    t20 = {
      OVERVIEW: t16,
      ATTEMPTS: t19
    };
    $[38] = t16;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  const TABS = t20 as const;
  let t21;
  if ($[41] !== mutate || $[42] !== mutateAttempts || $[43] !== mutateBookmarks) {
    t21 = (action, event_0, meta) => {
      bb53: switch (action) {
        case "retry":
          {
            mutate();
            mutateAttempts();
            break bb53;
          }
        case "replay":
          {
            mutate();
            break bb53;
          }
        case "bookmark":
          {
            mutateBookmarks(bookmarks_0 => ({
              ...bookmarks_0,
              models: [...(bookmarks_0?.models ?? []), ...(meta?.bookmark ? [meta?.bookmark] : [])]
            }));
          }
      }
    };
    $[41] = mutate;
    $[42] = mutateAttempts;
    $[43] = mutateBookmarks;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  const {
    retry,
    replay,
    bookmark
  } = useEventAction(t21);
  if (error && error.response?.status === 404) {
    const t22 = `Events are automatically archived after your plan ${subscription.retention_days} days retention period has passed.`;
    let t23;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = {
        to: "/events",
        text: "All Events"
      };
      $[45] = t23;
    } else {
      t23 = $[45];
    }
    let t24;
    if ($[46] !== event_id || $[47] !== t22) {
      t24 = <NotFound title="Event is archived or does not exist" description={t22} id={event_id} link={t23} />;
      $[46] = event_id;
      $[47] = t22;
      $[48] = t24;
    } else {
      t24 = $[48];
    }
    return t24;
  }
  if (!event || webhook_loading || !attempts || !bookmarks || event?.cli_id && !cli_clients) {
    let t22;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = {
        justify: "center"
      };
      $[49] = t22;
    } else {
      t22 = $[49];
    }
    let t23;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <Div flex={t22} p={8}><Loading /></Div>;
      $[50] = t23;
    } else {
      t23 = $[50];
    }
    return t23;
  }
  let t22;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      label: "Events",
      to: "/events"
    };
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== event_id) {
    t23 = <ViewBreadcrumbsTitle breadcrumbs={[t22, {
      label: event_id,
      highlight: true
    }]} />;
    $[52] = event_id;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== copyAsCurl) {
    t24 = <Tooltip tooltip="Copy request as cURL" side="bottom"><Button outline={true} icon="copy" onClick={copyAsCurl}>cURL</Button></Tooltip>;
    $[54] = copyAsCurl;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== bookmark || $[57] !== event) {
    t25 = () => bookmark(event);
    $[56] = bookmark;
    $[57] = event;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  const t26 = bookmarks.models.length > 0;
  const t27 = bookmarks.models.length > 0 ? "bookmark" : "bookmark_add";
  const t28 = bookmarks.models.length > 0 ? "Bookmarked" : "Bookmark";
  let t29;
  if ($[59] !== t25 || $[60] !== t26 || $[61] !== t27 || $[62] !== t28) {
    t29 = <Button.Permission role="member" outline={true} onClick={t25} disabled={t26} icon={t27}>{t28}</Button.Permission>;
    $[59] = t25;
    $[60] = t26;
    $[61] = t27;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== event || $[65] !== retry) {
    t30 = () => retry(event);
    $[64] = event;
    $[65] = retry;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  const t31 = webhook_error?.response?.status === 410;
  let t32;
  if ($[67] !== t30 || $[68] !== t31) {
    t32 = <Tooltip tooltip="Retry delivery of this event" side="bottom"><Button.Permission role="member" onClick={t30} outline={true} icon="retry" disabled={t31}>Retry</Button.Permission></Tooltip>;
    $[67] = t30;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== event || $[71] !== replay) {
    t33 = () => replay(event);
    $[70] = event;
    $[71] = replay;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  const t34 = !event.data;
  let t35;
  if ($[73] !== t33 || $[74] !== t34) {
    t35 = <Tooltip tooltip="Create new events from the original request" side="bottom"><Button.Permission role="member" onClick={t33} outline={true} icon="replay" disabled={t34}>Replay</Button.Permission></Tooltip>;
    $[73] = t33;
    $[74] = t34;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== t32 || $[77] !== t35) {
    t36 = <ButtonGroup>{t32}{t35}</ButtonGroup>;
    $[76] = t32;
    $[77] = t35;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  let t37;
  if ($[79] !== t24 || $[80] !== t29 || $[81] !== t36) {
    t37 = <StyledViewNavActions>{t24}{t29}{t36}</StyledViewNavActions>;
    $[79] = t24;
    $[80] = t29;
    $[81] = t36;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== t23 || $[84] !== t37) {
    t38 = <StyledViewNavHeader>{t23}{t37}</StyledViewNavHeader>;
    $[83] = t23;
    $[84] = t37;
    $[85] = t38;
  } else {
    t38 = $[85];
  }
  let t39;
  if ($[86] !== updateSearchQuery) {
    t39 = tab => updateSearchQuery({
      tab,
      selected_attempt_id: undefined
    });
    $[86] = updateSearchQuery;
    $[87] = t39;
  } else {
    t39 = $[87];
  }
  let t40;
  if ($[88] !== TABS) {
    t40 = Object.values(TABS);
    $[88] = TABS;
    $[89] = t40;
  } else {
    t40 = $[89];
  }
  let t41;
  if ($[90] !== t39 || $[91] !== t40) {
    t41 = <StyledViewNavSecondary><Tabs active_tab={current_status} onTabSelected={t39} border={false} tabs={t40} /></StyledViewNavSecondary>;
    $[90] = t39;
    $[91] = t40;
    $[92] = t41;
  } else {
    t41 = $[92];
  }
  let t42;
  if ($[93] !== t38 || $[94] !== t41) {
    t42 = <StyledViewNav>{t38}{t41}</StyledViewNav>;
    $[93] = t38;
    $[94] = t41;
    $[95] = t42;
  } else {
    t42 = $[95];
  }
  let t43;
  if ($[96] !== attempts || $[97] !== event || $[98] !== onAttemptSelected) {
    t43 = <Route exact={true} path="/events/:id"><EventOverview event={event} attempts={attempts} onAttemptSelected={onAttemptSelected} /></Route>;
    $[96] = attempts;
    $[97] = event;
    $[98] = onAttemptSelected;
    $[99] = t43;
  } else {
    t43 = $[99];
  }
  let t44;
  if ($[100] !== attempts || $[101] !== onAttemptSelected || $[102] !== selected_attempt_id) {
    t44 = <Route exact={true} path="/events/:id/attempts"><EventAttempts attempts={attempts} selected_attempt_id={selected_attempt_id} onAttemptSelected={onAttemptSelected} /></Route>;
    $[100] = attempts;
    $[101] = onAttemptSelected;
    $[102] = selected_attempt_id;
    $[103] = t44;
  } else {
    t44 = $[103];
  }
  let t45;
  if ($[104] !== t42 || $[105] !== t43 || $[106] !== t44) {
    t45 = <StyledViewContent>{t42}{t43}{t44}</StyledViewContent>;
    $[104] = t42;
    $[105] = t43;
    $[106] = t44;
    $[107] = t45;
  } else {
    t45 = $[107];
  }
  let t46;
  if ($[108] !== event_id || $[109] !== selected_attempt_id || $[110] !== updateSearchQuery) {
    t46 = selected_attempt_id && <EventSidebar event_id={event_id} attempt_id={selected_attempt_id} onSelectedAttempt={selected_attempt_id_1 => updateSearchQuery({
      selected_attempt_id: selected_attempt_id_1
    })} onClose={() => updateSearchQuery({}, {
      remove_keys: ["selected_attempt_id"]
    })} />;
    $[108] = event_id;
    $[109] = selected_attempt_id;
    $[110] = updateSearchQuery;
    $[111] = t46;
  } else {
    t46 = $[111];
  }
  let t47;
  if ($[112] !== t45 || $[113] !== t46) {
    t47 = <StyledViewLayout>{t45}{t46}</StyledViewLayout>;
    $[112] = t45;
    $[113] = t46;
    $[114] = t47;
  } else {
    t47 = $[114];
  }
  return t47;
};
export default EventView;